import { render, staticRenderFns } from "./superAdminGauge.vue?vue&type=template&id=5e7a586a&scoped=true"
import script from "./superAdminGauge.vue?vue&type=script&lang=js"
export * from "./superAdminGauge.vue?vue&type=script&lang=js"
import style0 from "./superAdminGauge.vue?vue&type=style&index=0&id=5e7a586a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a586a",
  null
  
)

export default component.exports